export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/404/icon-kw-logo-v4-4a204f3e2050cc48909f4e324ad36ace.svg";